/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * * `LESS_THAN_ONE_YEAR` - Less than 1 year
 * * `ONE_TO_TWO_YEARS` - 1-2 years
 * * `THREE_TO_FIVE_YEARS` - 3-5 years
 * * `SIX_TO_TEN_YEARS` - 6-10 years
 * * `TEN_PLUS_YEARS` - Mor than 10 years
 */
export enum RelationshipLengthEnum {
    LESS_THAN_ONE_YEAR = 'LESS_THAN_ONE_YEAR',
    ONE_TO_TWO_YEARS = 'ONE_TO_TWO_YEARS',
    THREE_TO_FIVE_YEARS = 'THREE_TO_FIVE_YEARS',
    SIX_TO_TEN_YEARS = 'SIX_TO_TEN_YEARS',
    TEN_PLUS_YEARS = 'TEN_PLUS_YEARS',
}
